import { useMemo, type ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { RoleContext, type RoleContextValue } from './RoleContext';

/** Exposes the signed-in user's role and permissions. Must sit inside a signed-in AuthProvider. */
export function RoleProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  const value = useMemo<RoleContextValue>(() => {
    const permissions = user?.permissions ?? [];
    return {
      roleId: user?.roleId ?? '',
      role: {
        id: user?.roleId ?? '',
        name: user?.roleName ?? '',
        approvalsCeiling: user?.approvalsCeiling ?? 'Not set',
        permissions,
      },
      permissions,
      can: (permission) => permissions.includes(permission),
    };
  }, [user]);

  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
}
